const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

export const getApiBaseUrl = () => {
  const envBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();

  if (envBaseUrl) {
    return trimTrailingSlash(envBaseUrl);
  }

  if (process.env.NODE_ENV === "production") {
    return "/api";
  }

  // CRA 개발 서버에서는 package.json proxy(http://localhost:3001)를 사용한다.
  return "/api";
};
